(function () {
  function build(root) {
    var container = root.querySelector('.cb-blog__slider');
    if (!container || container.swiper || !window.Swiper) return false;

    var list = container.querySelector('.cb-blog__grid');
    if (!list) return false;

    list.classList.add('swiper-wrapper');
    list.querySelectorAll('.cb-blog__item').forEach(function (item) {
      item.classList.add('swiper-slide');
    });
    container.classList.add('swiper');

    var outer = container.parentElement;
    outer.style.position = 'relative';

    var prev = document.createElement('div');
    prev.className = 'swiper-button-prev custom-slider-nav custom-slider-prev';
    outer.appendChild(prev);

    var next = document.createElement('div');
    next.className = 'swiper-button-next custom-slider-nav custom-slider-next';
    outer.appendChild(next);

    var mobile = Number(list.getAttribute('data-mobile')) || 1;
    var desktop = Number(list.getAttribute('data-desktop')) || 4;
    var mobileGap = Number(list.getAttribute('data-mobilegap')) || 12;
    var desktopGap = Number(list.getAttribute('data-desktopgap')) || 24;
    var centered = list.hasAttribute('data-align');
    var count = list.querySelectorAll('.cb-blog__item').length;

    new Swiper(container, {
      slidesPerView: mobile,
      slidesPerGroup: 1,
      spaceBetween: mobileGap,
      centeredSlides: centered,
      centeredSlidesBounds: centered, // ADD THIS LINE
      loop: false, // Keep loop false
      initialSlide: 0, // You can reset this to 0 now, the gap is gone
      watchOverflow: true,
      grabCursor: true,
      navigation: { prevEl: prev, nextEl: next },
      breakpoints: {
        750: { 
          slidesPerView: Math.min(3, desktop), 
          slidesPerGroup: 1, 
          spaceBetween: desktopGap, 
          centeredSlides: false,
          centeredSlidesBounds: false
        },
        990: { 
          slidesPerView: desktop, 
          slidesPerGroup: desktop, 
          spaceBetween: desktopGap, 
          centeredSlides: false,
          centeredSlidesBounds: false
        }
      }
    });

    return true;
  }

  function watch(root) {
    var tries = 0;
    var timer = setInterval(function () {
      if (build(root) || ++tries > 60) clearInterval(timer);
    }, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(document); });
  } else {
    watch(document);
  }

  document.addEventListener('shopify:section:load', function (event) { watch(event.target); });
})();
